<div [formGroup]="formGroup">
  <sc-flex >
    <mat-form-field appearance="fill">
      <mat-label>
        <sc-dictionary-label [dictionaryKey]="labelInput"></sc-dictionary-label>
      </mat-label>
      <input matInput [formControlName]="formControlName" readonly="{{disabled}}" [required]="!disabled"
              minlength="row.minLength" maxlength="255" />
    </mat-form-field>
    <sc-content-spacer [half]="true"></sc-content-spacer>
    <mat-checkbox (change)="withoutFahrzeug($event)">
      <sc-dictionary-label [dictionaryKey]="labelCheckbox"></sc-dictionary-label>
    </mat-checkbox>
  </sc-flex>
</div>
